import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=22432b06&"
import script from "./PromoCodes.vue?vue&type=script&lang=js&"
export * from "./PromoCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports